// extracted by mini-css-extract-plugin
module.exports = {"homunculusSvg":"Homunculus_homunculusSvg__2f8HS"};